export const makeDefaultLogger = () => {
  return console;
};